import {
  AccessTimeOutlined,
  AddCircleOutlined,
  CheckOutlined,
  ClearOutlined,
  DateRangeOutlined,
  DoDisturb,
  ErrorOutlineOutlined,
  EventRepeatOutlined,
  ManageHistoryOutlined,
  PersonPinCircleOutlined,
  SupportAgentOutlined,
  SyncOutlined,
  TroubleshootOutlined,
  TurnSlightRightOutlined,
} from "@mui/icons-material";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";
export function StatusChipModal(status) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const config = {
    aguardando_analise: {
      label: "Aguardando análise",
      icon: AccessTimeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    "EM ATENDIMENTO": {
      label: "Em atendimento",
      icon: AccessTimeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    resolvido: {
      label: "Resolvido",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    pendente: {
      label: "Pendente",
      icon: ErrorOutlineOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },

    PENDENTE: {
      label: "Pendente",
      icon: ErrorOutlineOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },
    Cancelado: {
      label: "Cancelado",
      icon: DoDisturb,
      bgColor: theme.palette.colors.gray.darker,
    },
    CANCELADO: {
      label: "Cancelado",
      icon: DoDisturb,
      bgColor: theme.palette.colors.gray.darker,
    },
    Aberto: {
      label: "Aberto",
      icon: ErrorOutlineOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.outputData,
    },
    Encaminhado: {
      label: "Encaminhado",
      icon: TurnSlightRightOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.speeData,
    },
    Agendado: {
      label: "Agendado",
      icon: DateRangeOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    "Em Análise": {
      label: "Em Análise",
      icon: TroubleshootOutlined,
      bgColor: theme.palette.colors.orange.darker,
    },
    Assumido: {
      label: "Assumido",
      icon: SupportAgentOutlined,
      bgColor: theme.palette.colors.blue.dark,
    },
    "Em execução": {
      label: "Em execução",
      icon: ManageHistoryOutlined,
      bgColor: theme.palette.colors.yellow.darker,
    },
    Finalizado: {
      label: "Finalizado",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    Deslocamento: {
      label: "Deslocamento",
      icon: PersonPinCircleOutlined,
      bgColor: theme.palette.colors.purple.dark,
    },
    Reagendar: {
      label: "Reagendar",
      icon: EventRepeatOutlined,
      bgColor: theme.palette.colors.pink.dark,
    },
    na: {
      label: "N/A",
      icon: ClearOutlined,
      bgColor: theme.palette.colors.gray.darker,
    },
    Novo: {
      label: "Novo",
      icon: AddCircleOutlined,
      bgColor: theme.palette.colors.blue.dark,
    },
    "Em progresso": {
      label: "Em progresso",
      icon: SyncOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.inputData,
    },
    Solucionado: {
      label: "Solucionado",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
    SOLUCIONADO: {
      label: "Solucionado",
      icon: CheckOutlined,
      bgColor: theme.palette.cardTrafficData.paperColor.statusUp,
    },
  };

  const current = config[status];
  if (!current) return null;

  const Icon = current.icon;

  return (
    <Tooltip title={current.label}>
      <Chip
        size="small"
        sx={{
          ...styles.chipStatus,
          backgroundColor: current.bgColor,
        }}
        label={
          <Box sx={styles.containerStatusModal}>
            <Typography sx={styles.titleChipModal}>{current.label}</Typography>
            <Icon sx={{ fontSize: "15px", color: theme.palette.white.main }} />
          </Box>
        }
      />
    </Tooltip>
  );
}
